import React from "react";

export function XIcon() {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.83936 0H11.747L7.58032 5.30556L12.5 12.5H8.63454L5.62249 8.13889L2.15863 12.5H0.251004L4.71888 6.83333L0 0H3.96586L6.70181 4L9.83936 0ZM9.16165 11.2222H10.2159L3.38855 1.19444H2.23394L9.16165 11.2222Z"
        fill="#222222"
      />
    </svg>
  );
}

export function SlackIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.39688 0C3.73438 0 3.19844 0.5375 3.19844 1.2C3.19844 1.51719 3.325 1.82344 3.54844 2.04844C3.77344 2.27344 4.07813 2.4 4.39688 2.4H5.59531V1.2C5.59531 0.539063 5.05938 0.0015625 4.39688 0ZM4.39688 3.2H1.19844C0.535937 3.2 0 3.7375 0 4.4C0 5.0625 0.5375 5.6 1.19844 5.6H4.39531C5.05781 5.6 5.59375 5.0625 5.59375 4.4C5.59531 3.7375 5.05781 3.2 4.39688 3.2ZM7.59375 5.6C8.25625 5.6 8.79375 5.0625 8.79219 4.4V1.2C8.79219 0.5375 8.25625 0 7.59375 0C6.93125 0 6.39531 0.5375 6.39531 1.2V4.4C6.39531 5.06406 6.93125 5.6 7.59375 5.6ZM11.9906 4.4C11.9906 3.7375 11.4531 3.2 10.7922 3.2C10.1313 3.2 9.59375 3.7375 9.59375 4.4V5.6H10.7922C11.4531 5.6 11.9906 5.0625 11.9906 4.4ZM10.7906 6.4H7.59375C6.93125 6.4 6.39531 6.9375 6.39531 7.6C6.39531 7.91719 6.52188 8.22344 6.74531 8.44844C6.97031 8.67344 7.275 8.8 7.59375 8.8H10.7906C11.4531 8.8 11.9891 8.2625 11.9891 7.6C11.9906 6.9375 11.4531 6.40156 10.7906 6.4ZM7.59375 9.6H6.39531V10.8C6.39531 11.4625 6.93281 12 7.59375 12C8.25625 12 8.79375 11.4625 8.79219 10.8C8.79375 10.1375 8.25625 9.60156 7.59375 9.6ZM4.39688 6.4C3.73438 6.4 3.19844 6.9375 3.19844 7.6V10.8C3.19844 11.4625 3.73594 12 4.39688 12C5.05938 12 5.59688 11.4625 5.59531 10.8V7.6C5.59531 7.28281 5.46875 6.97656 5.24531 6.75156C5.02031 6.52656 4.71406 6.4 4.39688 6.4ZM0 7.6C0 7.91719 0.126562 8.22344 0.35 8.44844C0.575 8.67344 0.879688 8.8 1.19844 8.8C1.86094 8.8 2.39844 8.2625 2.39688 7.6V6.4H1.19844C0.5375 6.4 0 6.9375 0 7.6Z"
        fill="#222222"
      />
    </svg>
  );
}

export function InstagramIcon() {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.24421 4.16296C5.09734 4.16296 4.1614 5.0989 4.1614 6.24578C4.1614 7.39265 5.09734 8.32859 6.24421 8.32859C7.39109 8.32859 8.32703 7.39265 8.32703 6.24578C8.32703 5.0989 7.39109 4.16296 6.24421 4.16296ZM12.4911 6.24578C12.4911 5.38328 12.4989 4.52859 12.4505 3.66765C12.402 2.66765 12.1739 1.78015 11.4427 1.0489C10.7098 0.31609 9.8239 0.0895272 8.8239 0.0410897C7.9614 -0.00734777 7.10671 0.000464756 6.24578 0.000464756C5.38328 0.000464756 4.52859 -0.00734777 3.66765 0.0410897C2.66765 0.0895272 1.78015 0.317652 1.0489 1.0489C0.31609 1.78171 0.0895272 2.66765 0.0410897 3.66765C-0.00734777 4.53015 0.000464756 5.38484 0.000464756 6.24578C0.000464756 7.10671 -0.00734777 7.96296 0.0410897 8.8239C0.0895272 9.8239 0.317652 10.7114 1.0489 11.4427C1.78171 12.1755 2.66765 12.402 3.66765 12.4505C4.53015 12.4989 5.38484 12.4911 6.24578 12.4911C7.10828 12.4911 7.96296 12.4989 8.8239 12.4505C9.8239 12.402 10.7114 12.1739 11.4427 11.4427C12.1755 10.7098 12.402 9.8239 12.4505 8.8239C12.5005 7.96296 12.4911 7.10828 12.4911 6.24578ZM6.24421 9.45046C4.47078 9.45046 3.03953 8.01921 3.03953 6.24578C3.03953 4.47234 4.47078 3.04109 6.24421 3.04109C8.01765 3.04109 9.4489 4.47234 9.4489 6.24578C9.4489 8.01921 8.01765 9.45046 6.24421 9.45046ZM9.58015 3.65828C9.16609 3.65828 8.83171 3.3239 8.83171 2.90984C8.83171 2.49578 9.16609 2.1614 9.58015 2.1614C9.99422 2.1614 10.3286 2.49578 10.3286 2.90984C10.3287 3.00816 10.3094 3.10554 10.2719 3.1964C10.2343 3.28726 10.1792 3.36982 10.1097 3.43934C10.0401 3.50886 9.95757 3.56399 9.86671 3.60156C9.77585 3.63913 9.67847 3.6584 9.58015 3.65828Z"
        fill="#222222"
      />
    </svg>
  );
}

export function LinkedInIcon() {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0H0.5C0.223437 0 0 0.223437 0 0.5V12C0 12.2766 0.223437 12.5 0.5 12.5H12C12.2766 12.5 12.5 12.2766 12.5 12V0.5C12.5 0.223437 12.2766 0 12 0ZM3.70781 10.6516H1.85313V4.68594H3.70781V10.6516ZM2.78125 3.87031C2.56863 3.87031 2.36079 3.80726 2.18401 3.68914C2.00723 3.57102 1.86944 3.40313 1.78808 3.2067C1.70672 3.01027 1.68543 2.79412 1.72691 2.58559C1.76838 2.37706 1.87077 2.18551 2.02111 2.03517C2.17145 1.88483 2.363 1.78245 2.57153 1.74097C2.78006 1.69949 2.9962 1.72078 3.19263 1.80214C3.38907 1.88351 3.55696 2.02129 3.67508 2.19807C3.7932 2.37486 3.85625 2.5827 3.85625 2.79531C3.85469 3.38906 3.37344 3.87031 2.78125 3.87031ZM10.6516 10.6516H8.79844V7.75C8.79844 7.05781 8.78594 6.16875 7.83438 6.16875C6.87031 6.16875 6.72188 6.92188 6.72188 7.7V10.6516H4.87031V4.68594H6.64844V5.50156H6.67344C6.92031 5.03281 7.525 4.5375 8.42813 4.5375C10.3063 4.5375 10.6516 5.77344 10.6516 7.37969V10.6516Z"
        fill="#222222"
      />
    </svg>
  );
}

export function FacebookIcon() {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0H0.5C0.223437 0 0 0.223437 0 0.5V12C0 12.2766 0.223437 12.5 0.5 12.5H12C12.2766 12.5 12.5 12.2766 12.5 12V0.5C12.5 0.223437 12.2766 0 12 0ZM10.5562 3.64844H9.55781C8.775 3.64844 8.62344 4.02031 8.62344 4.56719V5.77187H10.4922L10.2484 7.65781H8.62344V12.5H6.675V7.65938H5.04531V5.77187H6.675V4.38125C6.675 2.76719 7.66094 1.8875 9.10156 1.8875C9.79219 1.8875 10.3844 1.93906 10.5578 1.9625V3.64844H10.5562Z"
        fill="#222222"
      />
    </svg>
  );
}
